// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FinalScores_wrapper__34eZb","list":"FinalScores_list__1SWll","header":"FinalScores_header__2KHYR","label":"FinalScores_label__1TTL7"};